import { queryOptions } from '@tanstack/react-query';
import fetchClient from '@eureca/recruiter-api-sdk/client';

export interface MeSquadsResponse {
  count: number;
  primary?: { id: string; name: string };
  isAdmin: boolean;
}

export class MeSquadsFetchError extends Error {
  readonly name = 'MeSquadsFetchError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

async function fetchMeSquads(signal?: AbortSignal): Promise<MeSquadsResponse> {
  const res = await fetchClient<MeSquadsResponse>({
    method: 'GET',
    url: '/me/squads',
    signal,
  });
  if (res.error) {
    throw new MeSquadsFetchError(
      `Failed to load squad info (status ${res.error.status})`,
      res.error.status
    );
  }
  return res.data;
}

/**
 * TanStack Query options for `GET /me/squads`. Used by the listing page to
 * gate the "Criar empresa" button. JWT-projected on the BFF — cheap, no DB
 * touch — so a generous staleTime is fine.
 */
export function meSquadsQueryOptions() {
  return queryOptions({
    queryKey: ['recruiter', 'me', 'squads'] as const,
    queryFn: ({ signal }) => fetchMeSquads(signal),
    staleTime: 5 * 60_000,
    retry: (failureCount, err) => {
      if (err instanceof MeSquadsFetchError && err.status >= 400 && err.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
  });
}
